module.exports = __webpack_public_path__ + "static/greyvelourbunnyhamper-e081fe6a622bc11e19b31cac2c3f4208.jpeg";